import { render, staticRenderFns } from "./ReleasePerson2.vue?vue&type=template&id=57fca72e&scoped=true&"
import script from "./ReleasePerson2.vue?vue&type=script&lang=js&"
export * from "./ReleasePerson2.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePerson2.vue?vue&type=style&index=0&id=57fca72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fca72e",
  null
  
)

export default component.exports